import { getIndexerValueForMailboxInfo, type MailboxInfo } from "owa-client-types";
import type { StrictAcquisition } from "../types";
import { getItem } from "owa-local-storage";
import { logGreyError, logUsage } from "owa-analytics";

export function getCachedBizchatAcquisition(mailboxInfo?: MailboxInfo): StrictAcquisition | undefined {
    try {
        const mapKey = mailboxInfo ? getIndexerValueForMailboxInfo(mailboxInfo) : "default";
        const bizchatAcquisition = getItem(window, `BizchatAcquisition-${mapKey}`);
        
        logUsage("GetCachedBizchatAcquisition", mailboxInfo, {
            cacheHit: !!bizchatAcquisition,
        });
        
        if (bizchatAcquisition) {
            return JSON.parse(bizchatAcquisition) as StrictAcquisition;
        }
    }
    catch (error) {
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'Error | undefined'.
        // @ts-expect-error
        logGreyError("GetCachedBizchatAcquisitionError", mailboxInfo, error);
    }
    
    return undefined;
}
